import { useEffect, useState } from "react";

const HUBS = [
  { city: "Los Angeles", tz: "America/Los_Angeles" },
  { city: "New York", tz: "America/New_York" },
  { city: "London", tz: "Europe/London" },
  { city: "Dubai", tz: "Asia/Dubai" },
  { city: "Chennai", tz: "Asia/Kolkata" },
  { city: "Singapore", tz: "Asia/Singapore" },
  { city: "Tokyo", tz: "Asia/Tokyo" },
  { city: "Sydney", tz: "Australia/Sydney" },
];

function hubTime(tz) {
  const now = new Date();
  const time = new Intl.DateTimeFormat("en-US", { timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false }).format(now);
  const date = new Intl.DateTimeFormat("en-US", { timeZone: tz, weekday: "short", day: "numeric", month: "short" }).format(now);
  const hour = parseInt(new Intl.DateTimeFormat("en-US", { timeZone: tz, hour: "2-digit", hour12: false }).format(now), 10);
  const working = hour >= 9 && hour < 18;
  return { time, date, working };
}

export default function GlobalClock() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setTick((t) => t + 1), 1000 * 30);
    return () => clearInterval(i);
  }, []);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="global-clock">
      {HUBS.map((h) => {
        const t = hubTime(h.tz);
        return (
          <div key={h.city} className="rounded-xl bg-[#0B0F19] border border-white/10 px-4 py-3">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-slate-400">{h.city}</span>
              <span className={`h-1.5 w-1.5 rounded-full ${t.working ? "bg-emerald-400" : "bg-slate-600"}`} title={t.working ? "Working hours" : "After hours"} />
            </div>
            <div className="font-mono-metric text-lg font-bold text-white mt-1">{t.time}</div>
            <div className="text-[10px] text-slate-500">{t.date} · {t.working ? "On shift" : "Off"}</div>
          </div>
        );
      })}
    </div>
  );
}
